<template>
  <hb-section :title="$t('influencer_panel.channels')" :subtitle="subtitle">
    <div class="channels">
      <div v-for="row in channels" :key="row.key" class="channels__row">
        <div class="channels__head">
          <feather-icon :icon="iconFor(row.key)" size="15" :class="`text-${toneFor(row.key)}`" />
          <span class="channels__label">{{ row.label }}</span>
          <span class="channels__pct">{{ pctOf(row) }}%</span>
          <span class="channels__count">{{ row.conversions }}</span>
        </div>
        <div class="channels__bar">
          <div
            class="channels__bar-fill"
            :class="`channels__bar-fill--${toneFor(row.key)}`"
            :style="{ width: `${pctOf(row)}%` }"
          />
        </div>
      </div>
    </div>

    <p v-if="hasCoupon" class="channels__note">
      <feather-icon icon="InfoIcon" size="13" />
      {{ $t('influencer_panel.channels_coupon_note') }}
    </p>
  </hb-section>
</template>

<script>
import HbSection from '@/components/hubee/HbSection.vue'

/**
 * De onde vêm as vendas.
 *
 * A origem vem do canal escolhido na geração do link. Os dois baldes que não são canal —
 * cupom e não identificado — aparecem em cinza: escondê-los faria as porcentagens não
 * fecharem com o total de vendas da tela.
 */
const ICONS = {
  IG: 'InstagramIcon',
  BI: 'LinkIcon',
  WA: 'MessageCircleIcon',
  TT: 'ActivityIcon',
  YT: 'YoutubeIcon',
  OT: 'Share2Icon',
  coupon: 'TagIcon',
  unknown: 'HelpCircleIcon',
}

export default {
  name: 'SalesByChannel',
  components: { HbSection },
  props: {
    channels: { type: Array, default: () => [] },
  },
  computed: {
    total() {
      return this.channels.reduce((sum, row) => sum + Number(row.conversions || 0), 0)
    },
    subtitle() {
      return this.$t('influencer_panel.channels_hint', { count: this.total })
    },
    hasCoupon() {
      return this.channels.some(row => row.key === 'coupon')
    },
  },
  methods: {
    iconFor(key) {
      return ICONS[key] || 'Share2Icon'
    },
    toneFor(key) {
      return ['coupon', 'unknown'].includes(key) ? 'muted' : 'primary'
    },
    pctOf(row) {
      return this.total > 0 ? Math.round((Number(row.conversions || 0) / this.total) * 100) : 0
    },
  },
}
</script>

<style scoped>
.channels {
  display: flex;
  flex-direction: column;
  gap: 0.9rem;
}

.channels__head {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  margin-bottom: 0.35rem;
  font-size: var(--fs-sm);
}

.channels__label {
  color: var(--text-body);
}

.channels__pct {
  margin-left: auto;
  font-weight: var(--fw-medium);
  color: var(--text-heading);
}

.channels__count {
  min-width: 34px;
  text-align: right;
  color: var(--text-muted);
}

.channels__bar {
  height: 8px;
  border-radius: var(--radius-pill);
  background: var(--surface-sunken);
  overflow: hidden;
}

.channels__bar-fill {
  height: 100%;
  border-radius: var(--radius-pill);
}

.channels__bar-fill--primary {
  background: var(--primary);
}

.channels__bar-fill--muted {
  background: var(--gray-300);
}

.text-muted {
  color: var(--text-muted);
}

.channels__note {
  margin: 1rem 0 0;
  display: flex;
  align-items: center;
  gap: 0.4rem;
  font-size: var(--fs-xs);
  color: var(--text-muted);
}
</style>
